import React from 'react'
import {styledComponent} from '/app/src/higherOrderComponent'

class Flex extends React.Component {
    constructor(props){
        super(props)
        this.onClick = this.onClick.bind(this)
    }
    onClick(e){
        if(this.props.onClick) this.props.onClick(e)
    }

    render() {
        let { hostRef, children, className, style} = this.props
        let { onMouseEnter, onMouseLeave} = this.props
        return (
            <div
                onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}
                onClick={this.onClick} ref={hostRef} className={className} style={style}>
                {children}
            </div>
        );
    }
}

// Flex grow, shrink, basis
const getGrow = (props) => {
  const { grow } = props;
  if (typeof grow === 'number') {
    return grow;
  } else if (grow) {
    return 1;
  }
  return 0; // default
}
const getShrink = (props) => {
  const { shrink, basis } = props;
  if (typeof shrink === 'number') {
      return shrink;
  } else if (shrink) {
      return 1;
  } else if (shrink === false) {
      return 0;
  }
  if (basis && basis !== 'auto') {
      return 0;
  }
  return 1; // default
}
const getBasis = (props) => {
  const { basis } = props;
  if (basis) {
    const suffix = typeof basis === 'number' || String(parseInt(basis, 10)) === basis ? 'px' : '';
    return basis + suffix;
  }
  return 'auto'; // default
}
// Flex alignment
const alignPropToFlex = (content, props) => {
    const {center} = props
    if(center) return 'center'
    switch (content) {
        case 'top':
        case 'left': return 'flex-start'
        case 'bottom':
        case 'right': return 'flex-end'
        case 'center': return 'center'
        default: return undefined
  }
}

const StyledFlex =  styledComponent(Flex,
    (props) => {
        let customization = {
          // some browsers don't set these by default on flex
            minWidth: 0,
          // flex properties
            display: 'flex',
            flexDirection: props.column ? 'column' : 'row',
            flexWrap: props.wrap ? 'wrap' : 'nowrap',
            flex: `${getGrow(props)} ${getShrink(props)} ${getBasis(props)}`,
            justifyContent: alignPropToFlex(props.column ? props.vAlignContent : props.hAlignContent, props),
            alignItems: alignPropToFlex(props.column ? props.hAlignContent : props.vAlignContent, props),
        }
        return customization
    }
)
export default StyledFlex



// WEBPACK FOOTER //
// src/component/Flex/index.js